module.exports = __webpack_public_path__ + "static/displacement-b-b72ef3aa4f91567f10e58a326d655514.png";